(function() {
  var _clerkMounted         = false;
  var _rendered             = false;
  var _isGroupUser          = false;
  var _lastRenderedUserType = null;
  var _ghResolved           = false;

  // ── LANGUAGE ───────────────────────────────────────────────────────────────
  var _lang = 'en';
  try {
    var stored = localStorage.getItem('preferred_language');
    if (stored === 'es') _lang = 'es';
    // Also check Clerk user metadata
    if (window.Clerk && window.Clerk.user &&
        window.Clerk.user.unsafeMetadata &&
        window.Clerk.user.unsafeMetadata.preferred_language === 'es') {
      _lang = 'es';
    }
  } catch(e) {}

  var T = {
    en: {
      pageTitle:          'Group Settings',
      pageSubtitle:       'Manage your team members and group details.',
      myGroup:            'My Group',
      yourRole:           'Your Role',
      leaveDelete:        'Leave & Delete',
      memberDirectory:    'Member Directory',
      memberDirSubtitle:  'Controls whether all group members can see the full member list, or admins only.',
      showMemberList:     'Show member list to all members',
      showMemberListDesc: 'When enabled, every member of {orgName} can see who else is in the group. When disabled, only admins can view the full member list — useful for larger groups or privacy-conscious teams.',
      enabled:            'Enabled',
      disabled:           'Disabled',
      toChangeContact:    'To change, <a href="mailto:contact@grouphiit.com">contact support</a>.',
      managedByOwner:     'Managed by the group owner.',
      loadingMembers:     'Loading members...',
      memberListPrivate:  'Member List is Private',
      memberListPrivateDesc: 'The admins of {orgName} have restricted the member list to admins only.',
      yourGroup:          'Your group',
      members:            'members',
      member:             'member',
      groupAdmins:        'Group Admins',
      noAdmins:           'No admins found.',
      needHelp:           'Need help? Contact an admin above or email',
      manageMembership:   'Manage Membership →',
      manageSubNote:      'To manage your subscription or billing, visit',
      loginRequired:      'Login Required',
      loginRequiredDesc:  'Please log in to view and manage your group settings.',
      logIn:              'Log In',
      notInGroup:         'You aren\'t in a group yet',
      notInGroupDesc:     'Looking to work out with your team or family? Start a group membership or ask your group admin for an invite link.',
      viewGroupPlans:     'View Group Plans',
      loadingAdmins:      'Loading...',
      // Role labels
      ownerLabel:         'Group Owner',
      adminLabel:         'Group Admin',
      memberLabel:        'Member',
      // Role descriptions
      ownerDesc:          'You are the billing owner and primary administrator of {orgName}. You have full control over members, settings, and the subscription.',
      adminDesc:          'You are a delegated administrator of {orgName}. You can manage members and settings but do not control the subscription.',
      memberDesc:         'You are a member of {orgName}. You have access to all group workouts and content included in your group plan.',
      // Permissions
      pInvite:            'Invite and remove members',
      pRoles:             'Manage member roles',
      pEdit:              'Edit group name and logo',
      pBilling:           'Manage subscription and billing',
      pLeaveOwner:        'Leave group while the only admin',
      pLeaveAdmin:        'Leave group (if not the only admin)',
      pAccess:            'Access all group workouts and content',
      pNoInvite:          'Invite or remove members',
      pNoSettings:        'Manage group settings',
      pNoBilling:         'Manage subscription and billing',
      pLeaveAnytime:      'Leave group at any time',
      // Owner info box
      ownerInfoBox:       'You are the billing owner of {orgName}. To leave or transfer ownership, please <a href="mailto:contact@grouphiit.com">contact support</a>. To leave, you must first <a onclick="window.location.href=\'/pages/manage-membership\'">cancel your subscription</a> — your members will retain access until the end of the billing period.',
      // Leave info
      leaveOwnerIntro:    'You are the billing owner of {orgName}. To leave, you have two options:',
      leaveOwnerTransfer: '<strong>Transfer billing:</strong> Let your subscription expire, then ask another admin to go through checkout to take over the group plan. They will become the new billing owner and your members will continue without interruption.',
      leaveOwnerCancel:   '<strong>Cancel and leave:</strong> Cancel your subscription, then leave the group immediately — you do not need to wait for it to expire. Your members will retain access until the end of the current billing period, after which the group plan will end.',
      leaveOwnerNote:     'Note: You cannot leave if you are the only admin — please promote another member to admin first, or <a href="mailto:contact@grouphiit.com">contact support</a>.',
      leaveOwnerLinks:    '<a onclick="window.location.href=\'/pages/manage-membership\'">Manage Subscription →</a> &nbsp;·&nbsp; <a href="mailto:contact@grouphiit.com">Contact Support →</a>',
      leaveAdminDesc:     'As an admin, you can leave {orgName} as long as at least one other admin remains. If you are the only admin, please promote another member to admin before leaving.',
      leaveMemberDesc:    'You can leave {orgName} at any time. You will immediately lose access to all group workouts and content.',
      leaveGroupTitle:    'Leave Group',
      leaveGroupBtn:      'Leave Group',
      deleteGroupTitle:   'Delete Group',
      deleteGroupDesc:    'Permanently delete {orgName} as a group. All members will be removed, but their individual accounts will not be deleted — they will simply lose group access.',
      deleteGroupAccts:   'If you also need individual member accounts deleted, please <a href="mailto:contact@grouphiit.com">contact support</a> after deleting the group.',
      deleteGroupSub:     'You must cancel your subscription before deleting the group. This action cannot be undone.',
      deleteGroupNow:     '<strong>Want to end everything immediately?</strong> <a href="mailto:contact@grouphiit.com">Contact support</a> and we can cancel your subscription, remove all members, and delete the group in one step.',
      cancelFirst:        '<a onclick="window.location.href=\'/pages/manage-membership\'">Cancel Subscription First →</a>',
      deleteGroupBtn:     'Delete Group',
      adminOnlyDelete:    'Only the group owner can delete {orgName}. If you believe this group should be deleted, please <a href="mailto:contact@grouphiit.com">contact support</a>.',
      promoteFirst:       'Promote another admin first to enable this.',
      // Confirm dialogs
      confirmLeaveTitle:      'Leave this group?',
      confirmLeaveMsg:        'You will immediately lose access to all group workouts and content. This cannot be undone.',
      confirmLeaveBtn:        'Yes, Leave Group',
      confirmOwnerTitle:      'You are the billing owner',
      confirmOwnerMsg:        'Before leaving, make sure you have either cancelled your subscription or assigned another admin to take over billing. Your members will retain access until the end of the billing period. Do you want to continue?',
      confirmOwnerBtn:        'Yes, Continue',
      confirmOnlyAdminTitle:  'Cannot leave group',
      confirmOnlyAdminMsg:    'You are the only admin of this group. Please promote another member to admin before leaving, or contact support to dissolve the group.',
      confirmErrorTitle:      'Something went wrong',
      confirmErrorMsg:        'Could not leave the group. Please try again or contact support at contact@grouphiit.com.',
      ok:                     'OK',
    },
    es: {
      pageTitle:          'Configuración del Grupo',
      pageSubtitle:       'Administra tus miembros y los detalles del grupo.',
      myGroup:            'Mi Grupo',
      yourRole:           'Tu Rol',
      leaveDelete:        'Salir y Eliminar',
      memberDirectory:    'Directorio de Miembros',
      memberDirSubtitle:  'Controla si todos los miembros del grupo pueden ver la lista completa, o solo los administradores.',
      showMemberList:     'Mostrar lista de miembros a todos',
      showMemberListDesc: 'Cuando está activado, cada miembro de {orgName} puede ver quién más está en el grupo. Cuando está desactivado, solo los administradores pueden ver la lista.',
      enabled:            'Activado',
      disabled:           'Desactivado',
      toChangeContact:    'Para cambiar, <a href="mailto:contact@grouphiit.com">contacta soporte</a>.',
      managedByOwner:     'Gestionado por el propietario del grupo.',
      loadingMembers:     'Cargando miembros...',
      memberListPrivate:  'Lista de Miembros Privada',
      memberListPrivateDesc: 'Los administradores de {orgName} han restringido la lista de miembros solo para administradores.',
      yourGroup:          'Tu grupo',
      members:            'miembros',
      member:             'miembro',
      groupAdmins:        'Administradores del Grupo',
      noAdmins:           'No se encontraron administradores.',
      needHelp:           '¿Necesitas ayuda? Contacta a un administrador arriba o escribe a',
      manageMembership:   'Gestionar Membresía →',
      manageSubNote:      'Para gestionar tu suscripción o facturación, visita',
      loginRequired:      'Inicio de Sesión Requerido',
      loginRequiredDesc:  'Por favor inicia sesión para ver y gestionar la configuración de tu grupo.',
      logIn:              'Iniciar Sesión',
      notInGroup:         'Aún no estás en un grupo',
      notInGroupDesc:     '¿Quieres entrenar con tu equipo o familia? Inicia una membresía grupal o pídele a tu administrador un enlace de invitación.',
      viewGroupPlans:     'Ver Planes Grupales',
      loadingAdmins:      'Cargando...',
      ownerLabel:         'Propietario del Grupo',
      adminLabel:         'Administrador del Grupo',
      memberLabel:        'Miembro',
      ownerDesc:          'Eres el propietario de la facturación y administrador principal de {orgName}. Tienes control total sobre los miembros, la configuración y la suscripción.',
      adminDesc:          'Eres un administrador delegado de {orgName}. Puedes gestionar miembros y configuraciones, pero no controlas la suscripción.',
      memberDesc:         'Eres miembro de {orgName}. Tienes acceso a todos los entrenamientos y contenido del plan grupal.',
      pInvite:            'Invitar y eliminar miembros',
      pRoles:             'Gestionar roles de miembros',
      pEdit:              'Editar nombre y logo del grupo',
      pBilling:           'Gestionar suscripción y facturación',
      pLeaveOwner:        'Salir del grupo siendo el único administrador',
      pLeaveAdmin:        'Salir del grupo (si no eres el único admin)',
      pAccess:            'Acceso a todos los entrenamientos y contenido del grupo',
      pNoInvite:          'Invitar o eliminar miembros',
      pNoSettings:        'Gestionar configuración del grupo',
      pNoBilling:         'Gestionar suscripción y facturación',
      pLeaveAnytime:      'Salir del grupo en cualquier momento',
      ownerInfoBox:       'Eres el propietario de la facturación de {orgName}. Para salir o transferir la propiedad, <a href="mailto:contact@grouphiit.com">contacta soporte</a>. Para salir, primero debes <a onclick="window.location.href=\'/pages/manage-membership\'">cancelar tu suscripción</a> — tus miembros conservarán el acceso hasta el final del período de facturación.',
      leaveOwnerIntro:    'Eres el propietario de la facturación de {orgName}. Para salir, tienes dos opciones:',
      leaveOwnerTransfer: '<strong>Transferir la facturación:</strong> Deja que tu suscripción expire, luego pídele a otro administrador que complete el proceso de pago para asumir el plan grupal. Se convertirá en el nuevo propietario y tus miembros continuarán sin interrupciones.',
      leaveOwnerCancel:   '<strong>Cancelar y salir:</strong> Cancela tu suscripción y sal del grupo de inmediato — no necesitas esperar a que expire. Tus miembros conservarán el acceso hasta el final del período de facturación actual, después del cual el plan grupal terminará.',
      leaveOwnerNote:     'Nota: No puedes salir si eres el único administrador — primero promueve a otro miembro a administrador, o <a href="mailto:contact@grouphiit.com">contacta soporte</a>.',
      leaveOwnerLinks:    '<a onclick="window.location.href=\'/pages/manage-membership\'">Gestionar Suscripción →</a> &nbsp;·&nbsp; <a href="mailto:contact@grouphiit.com">Contactar Soporte →</a>',
      leaveAdminDesc:     'Como administrador, puedes salir de {orgName} siempre que al menos un administrador permanezca. Si eres el único administrador, promueve a otro miembro antes de salir.',
      leaveMemberDesc:    'Puedes salir de {orgName} en cualquier momento. Perderás acceso inmediatamente a todos los entrenamientos y contenido del grupo.',
      leaveGroupTitle:    'Salir del Grupo',
      leaveGroupBtn:      'Salir del Grupo',
      deleteGroupTitle:   'Eliminar Grupo',
      deleteGroupDesc:    'Eliminar permanentemente {orgName} como grupo. Todos los miembros serán removidos, pero sus cuentas individuales no se eliminarán — simplemente perderán el acceso al grupo.',
      deleteGroupAccts:   'Si también necesitas eliminar las cuentas individuales de los miembros, <a href="mailto:contact@grouphiit.com">contacta soporte</a> después de eliminar el grupo.',
      deleteGroupSub:     'Debes cancelar tu suscripción antes de eliminar el grupo. Esta acción no se puede deshacer.',
      deleteGroupNow:     '<strong>¿Quieres terminar todo de inmediato?</strong> <a href="mailto:contact@grouphiit.com">Contacta soporte</a> y podemos cancelar tu suscripción, eliminar a todos los miembros y eliminar el grupo en un solo paso.',
      cancelFirst:        '<a onclick="window.location.href=\'/pages/manage-membership\'">Cancelar Suscripción Primero →</a>',
      deleteGroupBtn:     'Eliminar Grupo',
      adminOnlyDelete:    'Solo el propietario del grupo puede eliminar {orgName}. Si crees que este grupo debe eliminarse, <a href="mailto:contact@grouphiit.com">contacta soporte</a>.',
      promoteFirst:       'Primero promueve a otro administrador para habilitar esto.',
      confirmLeaveTitle:      '¿Salir del grupo?',
      confirmLeaveMsg:        'Perderás acceso inmediatamente a todos los entrenamientos y contenido del grupo. Esto no se puede deshacer.',
      confirmLeaveBtn:        'Sí, Salir del Grupo',
      confirmOwnerTitle:      'Eres el propietario de la facturación',
      confirmOwnerMsg:        'Antes de salir, asegúrate de haber cancelado tu suscripción o asignado otro administrador para asumir la facturación. Tus miembros conservarán el acceso hasta el final del período de facturación. ¿Deseas continuar?',
      confirmOwnerBtn:        'Sí, Continuar',
      confirmOnlyAdminTitle:  'No puedes salir del grupo',
      confirmOnlyAdminMsg:    'Eres el único administrador de este grupo. Por favor promueve a otro miembro a administrador antes de salir, o contacta soporte para disolver el grupo.',
      confirmErrorTitle:      'Algo salió mal',
      confirmErrorMsg:        'No se pudo salir del grupo. Por favor inténtalo de nuevo o contacta soporte en contact@grouphiit.com.',
      ok:                     'OK',
    }
  };

  function t(key, vars) {
    var str = (T[_lang] && T[_lang][key]) || T['en'][key] || key;
    if (vars) {
      Object.keys(vars).forEach(function(k) {
        str = str.replace(new RegExp('{' + k + '}', 'g'), vars[k]);
      });
    }
    return str;
  }

  // Set page title/subtitle based on language
  function applyPageLanguage() {
    var titleEl = document.getElementById('gp-title');
    var subEl   = document.getElementById('gp-subtitle');
    if (titleEl) titleEl.textContent = t('pageTitle');
    if (subEl)   subEl.textContent   = t('pageSubtitle');
  }

  // ── CONFIRM MODAL ──────────────────────────────────────────────────────────
  function ghConfirm(title, message, confirmLabel) {
    return new Promise(function(resolve) {
      var overlay    = document.getElementById('gh-confirm-modal');
      var titleEl    = document.getElementById('gh-modal-title');
      var msgEl      = document.getElementById('gh-modal-message');
      var confirmBtn = document.getElementById('gh-modal-confirm');
      var cancelBtn  = document.getElementById('gh-modal-cancel');

      titleEl.textContent    = title;
      msgEl.textContent      = message;
      confirmBtn.textContent = confirmLabel || t('ok');
      cancelBtn.textContent  = _lang === 'es' ? 'Cancelar' : 'Cancel';
      overlay.classList.add('active');

      function close(result) {
        overlay.classList.remove('active');
        confirmBtn.removeEventListener('click', onConfirm);
        cancelBtn.removeEventListener('click', onCancel);
        overlay.removeEventListener('click', onOverlay);
        resolve(result);
      }

      function onConfirm() { close(true); }
      function onCancel()  { close(false); }
      function onOverlay(e) { if (e.target === overlay) close(false); }

      confirmBtn.addEventListener('click', onConfirm);
      cancelBtn.addEventListener('click', onCancel);
      overlay.addEventListener('click', onOverlay);
    });
  }

  // ── TABS ───────────────────────────────────────────────────────────────────
  function initTabs() {
    document.querySelectorAll('.gh-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        document.querySelectorAll('.gh-tab').forEach(function(t) { t.classList.remove('active'); });
        document.querySelectorAll('.gh-tab-panel').forEach(function(p) { p.classList.remove('active'); });
        tab.classList.add('active');
        var target = document.getElementById(tab.dataset.panel);
        if (target) target.classList.add('active');
      });
    });
  }

  // ── MEMBER VISIBILITY ──────────────────────────────────────────────────────
  function getMemberVisibility() {
    return (window.Clerk && window.Clerk.organization &&
      window.Clerk.organization.publicMetadata &&
      window.Clerk.organization.publicMetadata.setting_member_visibility) || 'on';
  }

  // ── LEAVE GROUP ────────────────────────────────────────────────────────────
  async function leaveOrganization() {
    var isOwner = window.GH && window.GH.userType === 'group_owner';

    if (isOwner) {
      var ownerWarning = await ghConfirm(
        t('confirmOwnerTitle'),
        t('confirmOwnerMsg'),
        t('confirmOwnerBtn')
      );
      if (!ownerWarning) return;
    }

    var confirmed = await ghConfirm(
      t('confirmLeaveTitle'),
      t('confirmLeaveMsg'),
      t('confirmLeaveBtn')
    );
    if (!confirmed) return;

    try {
      var orgMemberships = await window.Clerk.organization.getMemberships({ limit: 100 });
      var admins = orgMemberships.data.filter(function(m) { return m.role === 'org:admin'; });
      var isOnlyAdmin = admins.length === 1 && admins[0].publicUserData.userId === window.Clerk.user.id;

      if (isOnlyAdmin) {
        await ghConfirm(t('confirmOnlyAdminTitle'), t('confirmOnlyAdminMsg'), t('ok'));
        return;
      }

      var userMemberships = await window.Clerk.user.getOrganizationMemberships();
      var currentMembership = userMemberships.data.find(function(m) {
        return m.organization.id === window.Clerk.organization.id;
      });

      if (currentMembership) {
        await currentMembership.destroy();
        window.location.href = '/pages/join-group-hiit';
      } else {
        throw new Error('Membership not found');
      }
    } catch(e) {
      console.warn('[GH] Leave org error:', e);
      await ghConfirm(t('confirmErrorTitle'), t('confirmErrorMsg'), t('ok'));
    }
  }

  // ── LOAD ADMIN LIST ────────────────────────────────────────────────────────
  async function loadAdminList(containerId) {
    var container = document.getElementById(containerId);
    if (!container || !window.Clerk || !window.Clerk.organization) return;

    try {
      var memberships = await window.Clerk.organization.getMemberships({ limit: 100 });
      var admins = memberships.data.filter(function(m) { return m.role === 'org:admin'; });

      if (!admins.length) {
        container.innerHTML = '<p style="font-size:12px;color:#b0bec5;">' + t('noAdmins') + '</p>';
        return;
      }

      container.innerHTML = admins.map(function(m) {
        var first    = m.publicUserData.firstName || '';
        var last     = m.publicUserData.lastName  || '';
        var name     = (first + ' ' + last).trim() || m.publicUserData.identifier || 'Admin';
        var email    = m.publicUserData.identifier || '';
        var imgUrl   = m.publicUserData.imageUrl   || '';
        var initials = name.split(' ').map(function(n) { return n[0]; }).join('').toUpperCase().slice(0,2);

        return '<div class="gh-admin-item">' +
          '<div class="gh-admin-avatar">' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + name + '">' : initials) +
          '</div>' +
          '<div>' +
            '<div class="gh-admin-name">' + name + '</div>' +
            (email ? '<div class="gh-admin-email">' + email + '</div>' : '') +
          '</div>' +
        '</div>';
      }).join('');
    } catch(e) {
      console.warn('[GH] Could not load admins:', e);
      container.innerHTML = '<p style="font-size:12px;color:#b0bec5;">Could not load admin list.</p>';
    }
  }

  // ── CHECK OWNER CAN LEAVE ──────────────────────────────────────────────────
  async function checkOwnerCanLeave() {
    try {
      var orgMemberships = await window.Clerk.organization.getMemberships({ limit: 100 });
      var admins = orgMemberships.data.filter(function(m) { return m.role === 'org:admin'; });
      var isOnlyAdmin = admins.length === 1 && admins[0].publicUserData.userId === window.Clerk.user.id;

      var leaveBtn = document.getElementById('leave-btn');
      if (!leaveBtn) return;

      if (isOnlyAdmin) {
        leaveBtn.disabled = true;
        leaveBtn.classList.remove('gh-btn-danger');
        leaveBtn.classList.add('gh-btn-disabled');
        leaveBtn.title = t('promoteFirst');
        var note = document.createElement('p');
        note.style.cssText = 'font-size:11px;color:#94a3b8;margin-top:8px;text-align:right;';
        note.textContent = t('promoteFirst');
        leaveBtn.parentNode.appendChild(note);
      }
    } catch(e) {
      console.warn('[GH] Could not check admin count:', e);
    }
  }

  // ── LOAD MEMBER LIST ───────────────────────────────────────────────────────
  async function loadMemberList(containerId, orgName) {
    var container = document.getElementById(containerId);
    if (!container || !window.Clerk || !window.Clerk.organization) return;

    try {
      var memberships = await window.Clerk.organization.getMemberships({ limit: 100 });
      var members = memberships.data;
      var currentUserId = window.Clerk.user.id;
      var orgImageUrl = (window.Clerk.organization && window.Clerk.organization.imageUrl) || '';
      var memberWord = members.length === 1 ? t('member') : t('members');

      var headerHTML =
        '<div class="gh-member-list-header">' +
          (orgImageUrl ? '<img src="' + orgImageUrl + '" alt="' + orgName + '" style="width:48px;height:48px;border-radius:12px;object-fit:cover;border:1px solid #e2e8f0;flex-shrink:0;">' : '') +
          '<div>' +
            '<h3 style="margin:0 0 2px 0;">' + orgName + '</h3>' +
            '<p class="gh-member-count">' + members.length + ' ' + memberWord + '</p>' +
          '</div>' +
        '</div>';

      var youLabel = _lang === 'es' ? 'Tú' : 'You';

      var listHTML = members.map(function(m) {
        var first    = m.publicUserData.firstName || '';
        var last     = m.publicUserData.lastName  || '';
        var name     = (first + ' ' + last).trim() || (_lang === 'es' ? 'Miembro' : 'Member');
        var imgUrl   = m.publicUserData.imageUrl  || '';
        var initials = name.split(' ').map(function(n) { return n[0]; }).join('').toUpperCase().slice(0,2);
        var isYou    = m.publicUserData.userId === currentUserId;

        return '<div class="gh-member-list-item">' +
          '<div class="gh-member-avatar">' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + name + '">' : initials) +
          '</div>' +
          '<div class="gh-member-name">' +
            name +
            (isYou ? '<span class="gh-member-you">' + youLabel + '</span>' : '') +
          '</div>' +
        '</div>';
      }).join('');

      container.innerHTML = headerHTML + listHTML;
    } catch(e) {
      console.warn('[GH] Could not load member list:', e);
      container.innerHTML = '<p style="font-size:12px;color:#b0bec5;padding:16px 0;">Could not load members.</p>';
    }
  }

  // ── MOUNT CLERK ORG COMPONENT ──────────────────────────────────────────────
  function mountClerkOrgComponent() {
    if (_clerkMounted) return;
    var orgContainer = document.getElementById('clerk-org-profile-container');
    if (!orgContainer) return;
    if (!window.Clerk || typeof window.Clerk.mountOrganizationProfile !== 'function') return;

    window.Clerk.mountOrganizationProfile(orgContainer, {
      appearance: {
        variables: {
          colorPrimary: '#00bcd4',
          fontFamily: 'Poppins, sans-serif',
          borderRadius: '12px',
          spacingUnit: '14px',
        }
      }
    });
    _clerkMounted = true;
  }

  // ── MAIN RENDER ────────────────────────────────────────────────────────────
  window.renderGroupSettingsPage = function() {
    var root = document.getElementById('gh-group-content');
    if (!root) return;
    if (!window.Clerk || window.Clerk.user === undefined) return;

    // Detect language from user metadata if available
    if (window.Clerk.user && window.Clerk.user.unsafeMetadata &&
        window.Clerk.user.unsafeMetadata.preferred_language === 'es') {
      _lang = 'es';
    }
    applyPageLanguage();

    // Don't render state 3 until GH has resolved
    if (!_ghResolved && window.Clerk.user && window.Clerk.organization) return;

    // STATE 1: Logged out
    if (!window.Clerk.user) {
      _rendered = false;
      root.innerHTML =
        '<div class="gh-empty-state">' +
          '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>' +
          '<h3>' + t('loginRequired') + '</h3>' +
          '<p>' + t('loginRequiredDesc') + '</p>' +
          '<button class="gh-btn gh-btn-primary" onclick="window.Clerk.openSignIn()">' + t('logIn') + '</button>' +
        '</div>';
      return;
    }

    // STATE 2: No org yet
    if (!window.Clerk.organization) {
      if (_isGroupUser) {
        var membership = window.Clerk.user.organizationMemberships &&
                         window.Clerk.user.organizationMemberships[0];
        if (membership && membership.organization && membership.organization.id) {
          window.Clerk.setActive({ organization: membership.organization.id })
            .then(function() { window.renderGroupSettingsPage(); })
            .catch(function(e) { console.warn('[GH] setActive failed:', e); });
        }
        return;
      }
      if (!_rendered) {
        root.innerHTML =
          '<div class="gh-empty-state">' +
            '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/></svg>' +
            '<h3>' + t('notInGroup') + '</h3>' +
            '<p>' + t('notInGroupDesc') + '</p>' +
            '<button class="gh-btn gh-btn-primary" onclick="window.location.href=\'/pages/join-group-hiit\'">' + t('viewGroupPlans') + '</button>' +
          '</div>';
      }
      return;
    }

    // STATE 3: In a group — render once per userType
    if (_rendered) return;
    _rendered = true;
    

   // Derive role from active org membership, not GH global (which reflects primary org)
var userType = window.GH && window.GH.userType; // fallback only
var clerkRole = null;
try {
  var activeMemberships = window.Clerk.user.organizationMemberships;
  var activeOrgId = window.Clerk.organization.id;
  var activeMem = activeMemberships && activeMemberships.find(function(m) {
    return m.organization.id === activeOrgId;
  });
  if (activeMem) clerkRole = activeMem.role; // 'org:admin' or 'org:member'
} catch(e) {}

// Map Clerk role to GH userType for active org
// Only treat as owner if GH also confirms AND it's the same org
var ghIsOwnerOfThisOrg = (window.GH && window.GH.userType === 'group_owner' &&
  window.Clerk.organization.id === (window.GH.orgId || window.Clerk.organization.id));

var billingUserId = window.Clerk.organization.publicMetadata?.billingUserId;
var hasGhFlag = window.Clerk.organization.publicMetadata?.ghprogramall === true ||
                window.Clerk.organization.publicMetadata?.ghprogramall === 'true';
var noBillingAssignedYet = !billingUserId && !hasGhFlag;

var isOwner = ghIsOwnerOfThisOrg && clerkRole === 'org:admin';

// FALLBACK: If billing hasn't been set up yet and this user is the sole admin,
// treat them as the de facto owner so the UI reflects their actual role.
var isSoleAdminPendingCheckout = false;
if (!isOwner && clerkRole === 'org:admin' && noBillingAssignedYet) {
  // We'll confirm sole-admin status async below; assume true optimistically for render,
  // then correct if wrong via loadAdminList's count.
  isSoleAdminPendingCheckout = true;
  isOwner = true;
}

var isAdmin  = !isOwner && clerkRole === 'org:admin';
var isMember = clerkRole === 'org:member' || (!isOwner && !isAdmin);
var canManage = isOwner || isAdmin;

// Also fix userType string for anything downstream that uses it
userType = isOwner ? 'group_owner' : isAdmin ? 'group_admin' : 'group_member';

// STATE 3a: In org but subscription expired — not the owner
// Only fire this if GH.hasAccess is actually about THIS org, not a different one
var ghOrgMatchesActive = !window.GH.orgId || 
  (window.GH.orgId === window.Clerk.organization.id);

if (!window.GH.hasAccess && !isOwner && window.Clerk.organization && ghOrgMatchesActive) {
  var expOrgName = window.Clerk.organization.name || 'your group';
  var expOrgImg  = window.Clerk.organization.imageUrl || '';
  root.innerHTML =
    '<div style="display:flex;justify-content:flex-end;margin-bottom:16px;" id="gh-org-switcher-mount"></div>' +
    '<div class="gh-card">' +
      '<div style="display:flex;align-items:center;gap:14px;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #f1f5f9;">' +
        (expOrgImg ? '<img src="' + expOrgImg + '" alt="' + expOrgName + '" style="width:48px;height:48px;border-radius:12px;object-fit:cover;border:1px solid #e2e8f0;flex-shrink:0;">' : '') +
        '<div><h3 style="margin:0 0 2px 0;">' + expOrgName + '</h3><p style="font-size:12px;color:#37474f;margin:0;">Your group</p></div>' +
      '</div>' +
      '<div style="background:#fef2f2;border:1px solid #fecaca;border-radius:12px;padding:16px 20px;display:flex;align-items:flex-start;gap:12px;">' +
        '<svg style="width:20px;height:20px;color:#ef4444;flex-shrink:0;margin-top:1px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>' +
        '<div>' +
          '<p style="font-size:13px;font-weight:700;color:#ef4444;margin:0 0 4px 0;">Group Subscription Expired</p>' +
          '<p style="font-size:12px;color:#37474f;margin:0;">The subscription for ' + expOrgName + ' has expired. Please contact your group administrator to renew, or <a onclick="window.location.href=\'/pages/join-group-hiit\'" style="color:#00bcd4;font-weight:600;">start your own membership</a>.</p>' +
        '</div>' +
      '</div>' +
    '</div>';

  // Mount switcher even on expired screen
  var switcherMount = document.getElementById('gh-org-switcher-mount');
  if (switcherMount && window.Clerk && typeof window.Clerk.mountOrganizationSwitcher === 'function') {
    window.Clerk.mountOrganizationSwitcher(switcherMount, {
      hidePersonal: true,
      afterSelectOrganizationUrl: '/pages/group-profile',
      afterCreateOrganizationUrl: '/pages/join-group-hiit?step=2&planType=group&plan=group_growth&period=monthly',
      appearance: {
        variables: { colorPrimary: '#00bcd4', fontFamily: 'Poppins, sans-serif' },
        elements: {
          organizationSwitcherTrigger: 'border:1px solid #e2e8f0;border-radius:8px;padding:6px 12px;font-size:13px;font-weight:600;',
          
        }
      }
    });
  }
  return;
}

var orgName   = (window.Clerk.organization && window.Clerk.organization.name) || (_lang === 'es' ? 'tu grupo' : 'your group');
var memberVis = getMemberVisibility();
var showList  = memberVis !== 'off';

var subEl = document.getElementById('gp-subtitle');
if (subEl) {
  subEl.textContent = canManage
    ? (_lang === 'es' ? 'Administra tus miembros y los detalles del grupo.' : 'Manage your team members and group details.')
    : (_lang === 'es' ? 'Ve los detalles y miembros de tu grupo.' : 'View your group details and fellow members.');
}
    var roleConfigs = {
      group_owner: {
        label: t('ownerLabel'), badgeClass: 'owner',
        description: t('ownerDesc', { orgName: orgName }),
        permissions: [
          { yes: true,  text: t('pInvite') },
          { yes: true,  text: t('pRoles') },
          { yes: true,  text: t('pEdit') },
          { yes: true,  text: t('pBilling') },
          { yes: false, text: t('pLeaveOwner') },
        ]
      },
      group_admin: {
        label: t('adminLabel'), badgeClass: 'admin',
        description: t('adminDesc', { orgName: orgName }),
        permissions: [
          { yes: true,  text: t('pInvite') },
          { yes: true,  text: t('pRoles') },
          { yes: true,  text: t('pEdit') },
          { yes: false, text: t('pBilling') },
          { yes: true,  text: t('pLeaveAdmin') },
        ]
      },
      group_member: {
        label: t('memberLabel'), badgeClass: 'member',
        description: t('memberDesc', { orgName: orgName }),
        permissions: [
          { yes: true,  text: t('pAccess') },
          { yes: false, text: t('pNoInvite') },
          { yes: false, text: t('pNoSettings') },
          { yes: false, text: t('pNoBilling') },
          { yes: true,  text: t('pLeaveAnytime') },
        ]
      }
    };

    var role = roleConfigs[userType] || roleConfigs['group_member'];

    var permissionsHTML = role.permissions.map(function(p) {
      return '<li><span class="gh-perm-icon ' + (p.yes ? 'yes' : 'no') + '">' + (p.yes ? '✓' : '✕') + '</span>' + p.text + '</li>';
    }).join('');

    var ownerInfoHTML = isOwner
      ? '<div class="gh-info-box">' + t('ownerInfoBox', { orgName: orgName }) + '</div>'
      : '';

    // Leave info
    var leaveInfoHTML;
    if (isOwner) {
      leaveInfoHTML =
        '<p>' + t('leaveOwnerIntro', { orgName: orgName }) + '</p>' +
        '<p>' + t('leaveOwnerTransfer') + '</p>' +
        '<p>' + t('leaveOwnerCancel') + '</p>' +
        '<p>' + t('leaveOwnerNote') + '</p>' +
        '<p>' + t('leaveOwnerLinks') + '</p>';
    } else if (isAdmin) {
      leaveInfoHTML = '<p>' + t('leaveAdminDesc', { orgName: orgName }) + '</p>';
    } else {
      leaveInfoHTML = '<p>' + t('leaveMemberDesc', { orgName: orgName }) + '</p>';
    }

var expiredDangerNote = (!window.GH.hasAccess && (isOwner || isAdmin))
  ? '<div class="gh-info-box" style="margin-bottom:16px;border-color:#fecaca;background:#fef2f2;">' +
      'Your subscription has expired. Your members no longer have access. You can renew below, or delete the group using the button below.' +
      ' <a onclick="window.location.href=\'/pages/manage-membership\'">Renew subscription →</a>' +
    '</div>'
  : '';

// Delete section
var deleteHTML = isOwner
  ? '<div class="gh-danger-item">' +
      '<div class="gh-danger-item-info">' +
        '<h4>' + t('deleteGroupTitle') + '</h4>' +
        '<p>' + t('deleteGroupDesc', { orgName: orgName }) + '</p>' +
        '<p>' + t('deleteGroupAccts') + '</p>' +
        '<p>' + t('deleteGroupSub') + '</p>' +
        '<p>' + t('deleteGroupNow') + '</p>' +
        (!window.GH.hasAccess ? '' : '<p>' + t('cancelFirst') + '</p>') +
      '</div>' +
      (!window.GH.hasAccess
        ? '<button class="gh-btn gh-btn-danger" id="delete-btn">' + t('deleteGroupBtn') + '</button>'
        : '<button class="gh-btn gh-btn-disabled" disabled>' + t('deleteGroupBtn') + '</button>') +
    '</div>'
  : '';

var adminNoteHTML = isAdmin
  ? '<div class="gh-info-box">' + t('adminOnlyDelete', { orgName: orgName }) + '</div>'
  : '';

// Panel 1: My Group
var panel1HTML;
var subExpiredBanner = (!window.GH.hasAccess && (isOwner || isAdmin))
  ? '<div style="background:#fef2f2;border:1px solid #fecaca;border-radius:12px;padding:16px 20px;margin-bottom:16px;display:flex;align-items:flex-start;gap:12px;">' +
      '<svg style="width:20px;height:20px;color:#ef4444;flex-shrink:0;margin-top:1px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>' +
      '<div>' +
        '<p style="font-size:13px;font-weight:700;color:#ef4444;margin:0 0 4px 0;">Subscription Expired</p>' +
        '<p style="font-size:12px;color:#37474f;margin:0;">Your group subscription has expired. Your members have lost access to workouts and content. <a onclick="window.location.href=\'/pages/manage-membership\'" style="color:#00bcd4;font-weight:600;">Renew your subscription →</a></p>' +
      '</div>' +
    '</div>'
  : '';
var pendingCheckoutBanner = '';
if (isSoleAdminPendingCheckout) {
  if (window.GH.userType === 'individual' || (window.GH.hasAccess && !window.GH.orgId)) {
    pendingCheckoutBanner =
      '<div style="background:#fffbeb;border:1px solid #fde68a;border-radius:12px;padding:16px 20px;margin-bottom:16px;display:flex;align-items:flex-start;gap:12px;">' +
        '<svg style="width:20px;height:20px;color:#d97706;flex-shrink:0;margin-top:1px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>' +
        '<div>' +
          '<p style="font-size:13px;font-weight:700;color:#d97706;margin:0 0 4px 0;">You Have an Individual Membership</p>' +
          '<p style="font-size:12px;color:#37474f;margin:0;">You currently have an active individual membership, but this group has no active subscription yet. To activate this group and give your members access, you\'ll need to start a separate group membership. <a onclick="window.location.href=\'/pages/join-group-hiit\'" style="color:#00bcd4;font-weight:600;">Start a group membership →</a></p>' +
        '</div>' +
      '</div>';
  } else {
    pendingCheckoutBanner =
      '<div style="background:#fffbeb;border:1px solid #fde68a;border-radius:12px;padding:16px 20px;margin-bottom:16px;display:flex;align-items:flex-start;gap:12px;">' +
        '<svg style="width:20px;height:20px;color:#d97706;flex-shrink:0;margin-top:1px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>' +
        '<div>' +
          '<p style="font-size:13px;font-weight:700;color:#d97706;margin:0 0 4px 0;">Subscription Not Yet Active</p>' +
          '<p style="font-size:12px;color:#37474f;margin:0;">You created this group, but haven\'t completed checkout yet. Your members won\'t have access until billing is set up. <a onclick="window.location.href=\'/pages/join-group-hiit\'" style="color:#00bcd4;font-weight:600;">Complete checkout →</a></p>' +
        '</div>' +
      '</div>';
  }
}
if (canManage) {
  panel1HTML =
    subExpiredBanner +
     pendingCheckoutBanner +
    '<div class="gh-card">' +
      '<h3>' + t('memberDirectory') + '</h3>' +
      '<p class="gh-card-subtitle">' + t('memberDirSubtitle') + '</p>' +
      '<div class="gh-setting-row">' +
        '<div class="gh-setting-info">' +
          '<h4>' + t('showMemberList') + '</h4>' +
          '<p>' + t('showMemberListDesc', { orgName: orgName }) + '</p>' +
        '</div>' +
        '<div class="gh-setting-value">' +
          '<span class="gh-setting-badge ' + (showList ? 'on' : 'off') + '">' + (showList ? t('enabled') : t('disabled')) + '</span>' +
          (isOwner
            ? '<span class="gh-setting-contact">' + t('toChangeContact') + '</span>'
            : '<span class="gh-setting-contact">' + t('managedByOwner') + '</span>') +
        '</div>' +
      '</div>' +
    '</div>' +
    '<div id="clerk-org-profile-container"></div>';

} else if (isMember && showList) {
  panel1HTML =
    '<div class="gh-card">' +
      '<div id="gh-member-list-content">' +
        '<p style="font-size:12px;color:#b0bec5;">' + t('loadingMembers') + '</p>' +
      '</div>' +
    '</div>';

} else {
  var orgImgPrivate = (window.Clerk.organization && window.Clerk.organization.imageUrl) || '';
  panel1HTML =
    '<div class="gh-card">' +
      '<div style="display:flex;align-items:center;gap:14px;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #f1f5f9;">' +
        (orgImgPrivate ? '<img src="' + orgImgPrivate + '" alt="' + orgName + '" style="width:48px;height:48px;border-radius:12px;object-fit:cover;border:1px solid #e2e8f0;flex-shrink:0;">' : '') +
        '<div><h3 style="margin:0 0 2px 0;">' + orgName + '</h3><p style="font-size:12px;color:#37474f;margin:0;">' + t('yourGroup') + '</p></div>' +
      '</div>' +
      '<div style="text-align:center;padding:24px 0;">' +
        '<svg style="width:40px;height:40px;color:#b0bec5;margin:0 auto 12px;display:block;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>' +
        '<p style="font-size:13px;font-weight:600;color:#232a2e;margin:0 0 6px 0;">' + t('memberListPrivate') + '</p>' +
        '<p style="font-size:12px;color:#37474f;margin:0 auto;max-width:280px;">' + t('memberListPrivateDesc', { orgName: orgName }) + '</p>' +
      '</div>' +
    '</div>';
}
    root.innerHTML =
  '<div style="display:flex;justify-content:flex-end;margin-bottom:16px;" id="gh-org-switcher-mount"></div>' +
  '<div class="gh-tabs">' +
    '<button class="gh-tab active" data-panel="panel-members">' + t('myGroup') + '</button>' +
        '<button class="gh-tab" data-panel="panel-role">' + t('yourRole') + '</button>' +
        '<button class="gh-tab" data-panel="panel-danger">' + t('leaveDelete') + '</button>' +
      '</div>' +

      '<div class="gh-tab-panel active" id="panel-members">' + panel1HTML + '</div>' +

      '<div class="gh-tab-panel" id="panel-role">' +
        '<div class="gh-card">' +
          '<span class="gh-role-badge ' + role.badgeClass + '">' + role.label + '</span>' +
          '<p class="gh-role-description">' + role.description + '</p>' +
          '<ul class="gh-permissions">' + permissionsHTML + '</ul>' +
          ownerInfoHTML +
          '<div class="gh-admin-list">' +
            '<h4>' + t('groupAdmins') + '</h4>' +
            '<div id="admin-list-container"><p style="font-size:12px;color:#b0bec5;">' + t('loadingAdmins') + '</p></div>' +
            '<p style="font-size:12px;color:#37474f;margin-top:12px;">' + t('needHelp') + ' <a href="mailto:contact@grouphiit.com" style="color:#00bcd4;font-weight:600;">contact@grouphiit.com</a>.</p>' +
          '</div>' +
          (isMember ? '<div class="gh-info-box" style="margin-top:16px;">' + t('manageSubNote') + ' <a onclick="window.location.href=\'/pages/manage-membership\'">' + t('manageMembership') + '</a></div>' : '') +
        '</div>' +
      '</div>' +

      '<div class="gh-tab-panel" id="panel-danger">' +
        '<div class="gh-card">' +
            expiredDangerNote +
          '<div class="gh-danger-item">' +
            '<div class="gh-danger-item-info"><h4>' + t('leaveGroupTitle') + '</h4>' + leaveInfoHTML + '</div>' +
            '<button class="gh-btn gh-btn-danger" id="leave-btn">' + t('leaveGroupBtn') + '</button>' +
          '</div>' +
          deleteHTML +
          adminNoteHTML +
        '</div>' +
      '</div>';

    if (canManage) mountClerkOrgComponent();
    if (isMember && showList) loadMemberList('gh-member-list-content', orgName);
    if (isOwner || isAdmin) checkOwnerCanLeave();

    var leaveBtn = document.getElementById('leave-btn');
if (leaveBtn) leaveBtn.addEventListener('click', leaveOrganization);

var deleteBtn = document.getElementById('delete-btn');
if (deleteBtn) deleteBtn.addEventListener('click', async function() {
  var confirmed = await ghConfirm(
    'Delete this group?',
    'This will permanently delete ' + orgName + ' and remove all members. Their individual accounts will not be deleted. This cannot be undone.',
    'Yes, Delete Group'
  );
  if (!confirmed) return;
  try {
    await window.Clerk.organization.destroy();
    window.location.href = '/pages/join-group-hiit';
  } catch(e) {
    console.warn('[GH] Delete org error:', e);
    await ghConfirm('Something went wrong', 'Could not delete the group. Please contact support at contact@grouphiit.com.', 'OK');
  }
});

    initTabs();
    // Mount org switcher
var switcherMount = document.getElementById('gh-org-switcher-mount');
if (switcherMount && window.Clerk && typeof window.Clerk.mountOrganizationSwitcher === 'function') {
  window.Clerk.mountOrganizationSwitcher(switcherMount, {
    hidePersonal: true,
    afterSelectOrganizationUrl: '/pages/group-profile',
    afterCreateOrganizationUrl: '/pages/join-group-hiit?step=2&planType=group&plan=group_growth&period=monthly',
    appearance: {
      variables: {
        colorPrimary: '#00bcd4',
        fontFamily: 'Poppins, sans-serif',
      },
      elements: {
        organizationSwitcherTrigger: 'border:1px solid #e2e8f0;border-radius:8px;padding:6px 12px;font-size:13px;font-weight:600;',
        organizationSwitcherPopoverCard: 'font-family:Poppins,sans-serif;',
        organizationSwitcherPopoverActionButton: { display: 'none' }
      }
    }
  });
}
    loadAdminList('admin-list-container');
  };

  // ── INIT ───────────────────────────────────────────────────────────────────
  applyPageLanguage();

  document.addEventListener('gh:accessResolved', function(e) {
  _ghResolved = true;
  var detail   = e.detail || {};
  var userType = detail.userType || (window.GH && window.GH.userType);

  _isGroupUser = (userType === 'group_owner' || userType === 'group_admin' || userType === 'group_member');

  // Also treat as group user if they're physically in a Clerk org
  // even if subscription expired — so we can show the expired state
  if (!_isGroupUser && window.Clerk && window.Clerk.user &&
      window.Clerk.user.organizationMemberships &&
      window.Clerk.user.organizationMemberships.length > 0) {
    _isGroupUser = true;
  }

  if (_rendered && _lastRenderedUserType !== userType) {
    _rendered     = false;
    _clerkMounted = false;
  }
  _lastRenderedUserType = userType;

  window.renderGroupSettingsPage();
});

  if (window.GH && window.GH.userType !== undefined) {
    var ut = window.GH.userType;
    _isGroupUser = (ut === 'group_owner' || ut === 'group_admin' || ut === 'group_member');
    setTimeout(window.renderGroupSettingsPage, 50);
  }

  var _groupInterval = setInterval(function() {
    if (!window.Clerk || window.Clerk.user === undefined) return;
    if (_isGroupUser && !window.Clerk.organization) return;
    clearInterval(_groupInterval);
    window.renderGroupSettingsPage();
  }, 100);

  setTimeout(function() {
    clearInterval(_groupInterval);
    if (!_rendered) window.renderGroupSettingsPage();
  }, 8000);

})();